import { apiRequest } from "@services/apiClient";

export const fetchCallLogs = async (clinicId) => {
  return apiRequest({
    method: "GET",
    endpoint: `/call-matching/call-logs?clinic_id=${clinicId}`,
  });
};

export const fetchMatchingAppointments = async (clinicId) => {
  return apiRequest({
    method: "GET",
    endpoint: `/call-matching/appointments?clinic_id=${clinicId}`,
  });
};

export const createMatch = async (appointmentId, unifiCallLogId) => {
  return apiRequest({
    method: "POST",
    endpoint: "/call-matching/match",
    body: { appointment_id: appointmentId, unifi_call_log_id: unifiCallLogId },
  });
};

export const removeMatch = async (appointmentId) => {
  return apiRequest({
    method: "DELETE",
    endpoint: `/call-matching/match/${appointmentId}`,
  });
};
